<template>
  <div class="boxbgcolor finance">
    <!--左侧树形索引-->
    <div class="left content-left">
      <AreaTree ref="table" v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div>
    <div class="content-right">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <span class="demonstration">泊位段:</span>
            <el-select
              v-model="search.areaIds"
              multiple
              collapse-tags
              style="margin-left: 20px;"
              placeholder="请选择"
            >
              <el-option
                v-for="item in allAreaData"
                :key="item.areaId"
                :label="item.areaName"
                :value="item.areaId"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <span class="demonstration">月:</span>
            <el-date-picker v-model="value4" type="month" placeholder="选择月"></el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button @click="searchList" type="primary" :loading="loading" size="small">查询</el-button>
            </span>
            <span class="download_btn">
              <button @click="downloadExcel" type="button" class="btn btn-primary">导出EXCEl</button>
            </span>
            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
            <!-- <span class="download"><ExportExcel v-bind:tableListData="this.tableListData" v-bind:tableListDataAll="this.tableListDataAll" v-bind:downloadFileds="this.downloadFileds"></ExportExcel></span> -->
            <!-- <span class="refresh_btn">
              <div class="reload-container">
                <a class="reload" @click="reloads()">
                  <i class="el-icon-refresh"></i>刷新
                </a>
              </div>
            </span>-->
          </div>
        </form>
        <!-- <div class="download"></div> -->
      </div>
      <!-- <div class="show-date">{{showDate.year}}年{{showDate.month}}月</div> -->
      <div class="list">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          v-loading="loading"
        >
          <el-table-column show-overflow-tooltip label="泊位段名称" prop="areaName"></el-table-column>
          <el-table-column show-overflow-tooltip label="时间">
            <template slot-scope="scope">
              <span class="to-block">应收</span>
              <span class="to-block">实收</span>
              <span class="to-block last-row">收费率</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月1日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[0]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[0]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[0]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月2日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[1]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[1]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[1]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月3日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[2]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[2]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[2]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月4日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[3]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[3]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[3]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月5日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[4]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[4]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[4]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月6日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[5]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[5]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[5]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月7日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[6]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[6]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[6]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月8日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[7]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[7]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[7]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月9日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[8]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[8]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[8]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月10日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[9]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[9]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[9]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月11日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[10]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[10]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[10]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月12日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[11]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[11]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[11]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月13日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[12]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[12]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[12]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月14日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[13]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[13]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[13]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月15日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[14]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[14]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[14]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月16日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[15]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[15]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[15]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月17日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[16]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[16]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[16]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月18日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[17]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[17]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[17]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月19日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[18]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[18]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[18]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月20日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[19]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[19]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[19]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月21日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[20]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[20]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[20]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月22日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[21]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[21]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[21]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月23日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[22]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[22]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[22]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月24日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[23]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[23]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[23]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月25日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[24]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[24]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[24]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月26日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[25]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[25]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[25]).rate:''}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label='showDate.month+"月27日"'>
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[26]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[26]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[26]).rate:''}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column  show-overflow-tooltip label="28"> -->
          <el-table-column show-overflow-tooltip :label='showDate.month+"月28日"' v-if="twentyEighthShow">
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[27]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[27]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[27]).rate:''}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column  show-overflow-tooltip label="29"> -->
          <el-table-column show-overflow-tooltip :label='showDate.month+"月29日"' v-if="twentyNineShow">
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[28]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[28]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[28]).rate:''}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column  show-overflow-tooltip label="30"> -->
          <el-table-column show-overflow-tooltip :label='showDate.month+"月30日"' v-if="thirtyShow">
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[29]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[29]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[29]).rate:''}}</span>
            </template>
          </el-table-column>

          <el-table-column show-overflow-tooltip :label='showDate.month+"月31日"' v-if="thirtyOneShow">
            <template slot-scope="scope">
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[30]).receivable:''}}</span>
              <span
                class="to-block"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[30]).realMoney:''}}</span>
              <span
                class="to-block last-row"
              >{{scope.row.chargeDateList&&scope.row.chargeDateList.length!=0?(scope.row.chargeDateList[30]).rate:''}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import AreaTree from "../../commons/areaTree";
import {
  getChargeUserMonthyMoney,
  getChargeAreaStatisticsList,
  getAllAreaByParkingId
} from "@/api/url";

import Page from "../../commons/page";

export default {
  data() {
    return {
      styleObj: {
        "text-align": "center"
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB"
      },
      twentyEighthShow: false,
      twentyNineShow: false,
      thirtyShow: false,
      thirtyOneShow: false,
      lastColumn: "",
      treeData: {
        parentId: ""
      },
      moduleName: "",
      search: {
        pageNumber: 1,
        pageSize: 10,
        year: "",
        month: "",
        dates: "",
        areaIds: ""
      },
      value4: "",
      showDate: {
        year: "",
        month: ""
      },
      tableListData: [],
      allAreaData: [],
      tableListDataByDay: {},
      pageObj: {},
      loading: false
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function(node, data) {
      // this.search.beginDate='';
      // this.search.chargeDate='';
      // this.search.spaceNum='';
      this.getDateNow();
      this.value4 = "";
      this.search.month = "";
      this.search.year = "";
      this.search.dates = "";
      this.search.areaIds = "";
      if (node.type != "parking") {
        this.treeData.parentId = "";
        var pageObj = {
          curIndex: 1,
          rowsCount: 0
        };
        this.getPage(pageObj);
        this.tableListData.rows = [];
        // this.$message({
        // 	message: '请选择车场',
        // 	type: 'warning'
        // });
        return;
      } else {
        this.treeData.parentId = node.id;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
        this.allAreaByParkingId();
      }
    },

    tableList: function(curPage) {
      var _this = this;
      this.loading = true;
      this.reckonDate(this.value4);
      this.$get(getChargeAreaStatisticsList(), {
        areaIds: this.search.areaIds.toString(),
        parkingId: this.treeData.parentId,
        date: this.search.dates,
        limit: this.search.pageSize,
        page: curPage
      }).then(data => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total
        };
        this.pageObj={...pageObj}
        // _this.getPage(pageObj);

        // console.log(data.data.rows);

        _this.tableListData = data.data.rows;

        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    
    downloadExcel() {
      if (!this.treeData.parentId) {
        this.$message({
          type: "warning",
          message: "请选择道路"
        });
        return;
      }
      this.reckonDate(this.value4);
      var areaNames = [];
      if (this.search.areaIds.length > 0) {
        for (let y of this.search.areaIds) {
          for (let item of this.allAreaData) {
            if (y == item.areaId) {
              areaNames.push(item.areaName);
              break;
            }
          }
        }
      }
      this.$downloadFileRequest(
        "/api/parking/parkingOrders/chargeUserStatisticsExport", 
        {
          date: this.search.dates,
          parkingId: this.treeData.parentId,
          areaIds: this.search.areaIds.toString(),
          areaNames: areaNames.toString()
        },
        '岗位收费统计');
    },
    searchList() {
      
   
        var _this = this;
        this.search.pageNumber = "1";
        if (!this.treeData.parentId) {
          this.$message({
            type: "warning",
            message: "请选择道路"
          });
          return;
        }
        if (this.value4) {
          this.monthHasDays(this.value4);
        }

        this.tableList(this.search.pageNumber);
     
    },
    reckonDate(v) {
      if (v) {
        let yy = v.getFullYear();
        let mm = v.getMonth() + 1;
        this.showDate.year = yy;
        this.showDate.month = mm;
        this.search.month = mm;
        this.search.year =yy;
        if (mm.toString().length <= 1) {
          this.search.month = "0" + mm;
        } else {
          this.search.month = mm;
        }
      } else {
        var date = new Date();
        this.showDate.year = date.getFullYear();
        this.showDate.month = date.getMonth() + 1;
        this.search.year = date.getFullYear();
        let mm = date.getMonth() + 1;
        if (mm.toString().length <= 1) {
          this.search.month = "0" + mm;
        } else {
          this.search.month = mm;
        }
      }
      this.search.dates = this.search.year + "-" + this.search.month;
    },
    clearSearch: function() {
      // this.search.pageNumber = "1";
      // this.search.parkName = "";
    },
    getDateNow() {
      var date = new Date();
      this.showDate.year = date.getFullYear();
      this.showDate.month = date.getMonth() + 1;
      this.monthHasDays(date);
    },
    //计算某年某月有多少天
    monthHasDays(d) {
      let year=d.getFullYear().toString();
      let month=(d.getMonth()+1).toString();
      let dd=new Date(year,month,0)
      let days=dd.getDate()
      switch (days) {
        case 28: {
          this.twentyEighthShow = true;
          this.twentyNineShow = false;
          this.thirtyShow = false;
          this.thirtyOneShow = false;
          this.lastColumn = 29;
          break;
        }
        case 29: {
          this.twentyEighthShow = true;
          this.twentyNineShow = true;
          this.thirtyShow = false;
          this.thirtyOneShow = false;
          this.lastColumn = 30;
          break;
        }
        case 30: {
          this.twentyEighthShow = true;
          this.twentyNineShow = true;
          this.thirtyShow = true;
          this.thirtyOneShow = false;
          this.lastColumn = 31;
          break;
        }
        default: {
          this.twentyEighthShow = true;
          this.twentyNineShow = true;
          this.thirtyShow = true;
          this.thirtyOneShow = true;
          this.lastColumn = 32;
          break;
        }
      }
    },
    allAreaByParkingId() {
      this.allAreaData = [];
      this.$get(getAllAreaByParkingId(), {
        parkingId: this.treeData.parentId
      }).then(data => {
        if (data.status != 200) return this.$layer.msg(data.message);
        this.allAreaData = data.data;
      });
    }
  },
  computed: {
    /*...mapState({
				curIndex: state => state.page.curIndex,
				rowsCount: state => state.page.rowsCount
			}),*/

    ...mapGetters(["elements"]),
    // permiss(){
    // 	this.parklist_btn_add = this.elements['parklist:btn_add'];
    // 	this.parklist_btn_rule = this.elements['parklist:btn_rule'];
    // this.parklist_btn_pkset = this.elements['parklist:btn_pkset'];
    // this.parklist_btn_control = this.elements['parklist:btn_control'];
    // this.parklist_btn_person = this.elements['parklist:btn_person'];
    // this.parkset_btn_edit = this.elements['parklist:btn_edit'];
    // this.parklist_btn_remove=this.elements['parklist:btn_remove'];
    //console.log("parklist_btn_remove")
    //console.log(this.parklist_btn_remove)
    // }
    totalMoney() {
      var result = 0;
      if (this.tableListDataByDay) {
        let temp = this.tableListDataByDay;
        for (let key in temp) {
          result += parseFloat(temp[key]);
        }
      }
      return result.toFixed(2);
    }
  },
  components: {
    Page,
    AreaTree
  },
  created: function() {
    // this.permiss;
  },
  mounted: function() {
    // this.tableList(this.pageNumber);
    // this.tableListByDay();
    this.getDateNow();
  },
  watch: {
    elements: {
      handler: function(val, oldVal) {
        this.permiss;
      },
      deep: true //深度
    }
  }
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;
  /* height:65px; */
  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
  overflow-x: auto;
  height: calc(100vh - 250px) !important;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
table {
  border: 1px solid #ccc;
}
table tr td {
  border: 1px solid #ccc;
}
.reload-container {
  display: inline-block;
  /* margin-top:8px; */
}
.reload {
  /* margin: 0px 10px; */
  cursor: pointer;
  color: #67c23a !important;
}
.reload:hover {
  color: rgb(45, 107, 15) !important;
}
.show-date {
  text-align: center;
  height: 26px;
  line-height: 26px;
  background: #f9f9fb;
  font-size: 24px;
  font-weight: bold;
}
.to-block {
  display: block;
}
.list span{
  border-bottom:1px solid #eee;
}
.list span.last-row{
  border-bottom:none;
}
</style>
<style>
.finance .el-table__footer td .cell {
  text-align: center;
  font-weight: bold;
  color: black;
}
.el-table .cell, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell{
  padding-left:0!important;
}
.el-table .cell, .el-table th div{
   padding-right:0!important;
}
</style>